console.log('This site was generated by Hugo.');
